export const UNIT_SYSTEMS = {
  imperial: 'imperial',
  metric: 'metric',
};

export const UNIT_METADATA = {
  [UNIT_SYSTEMS.imperial]: {
    weldLengthLabel: 'Weld Length: Ft.',
    weldLengthPlaceholder: 'Enter length in feet',
    csaUnit: 'in²',
    depositionUnit: 'lbs/ft',
    fillerUnit: 'lbs',
  },
  [UNIT_SYSTEMS.metric]: {
    weldLengthLabel: 'Weld Length: M.',
    weldLengthPlaceholder: 'Enter length in meters',
    csaUnit: 'mm²',
    depositionUnit: 'grams/cm',
    fillerUnit: 'kgs',
  },
};

export function isMetric(unitSystem) {
  return unitSystem === UNIT_SYSTEMS.metric;
}
